
import Repository from './Repository';
import {AxiosResponse} from "axios";
import Config from '@/models/config.models'

const resource = '/config';

export default new class{
    getConfig(): Promise<AxiosResponse<Config>>{
        return Repository.get(resource);
    }
    saveConfig(config: Config): Promise<any>{
        return Repository.post(resource, config);
    }
}
